import React, { Dispatch, useState, useEffect, useContext, createContext, FC, SetStateAction } from "react";
import { getUser, login, isAuthed, logout } from '../services/auth';
import { removeData } from "../components/Shared/Functions";

interface IAuthContext {
    error?: any;
    authenticating?: boolean;
    authed?: boolean;
    login?: any;
    logout?: any;
    user?: any;
    updateUser?: Dispatch<SetStateAction<any>>;
}

const Context = createContext<IAuthContext>({});

// Wrapper component for authed domains
const SecureContext: FC = ({ children = null }) => {
    const auth = useSecurity();
    return <>
        <Context.Provider value={auth}>{children}</Context.Provider>
    </>
}

// Child component hook
function useSecurityStatus() {
    return useContext(Context);
}

// Main hook for Authenticated domain
function useSecurity() {
    const [error, setError] = useState(null);
    const [authenticating, setAuthenticating] = useState(true);
    const [authed, setAuthed] = useState(false);
    const [user, setUser] = useState(undefined);

    useEffect(() => {
        isAuthed()
            .then(isAuthed => {
                if (isAuthed) {
                    setAuthed(true)
                    getUser()
                        .then((user) => {
                            setUser(user);
                            setAuthenticating(false);
                            setAuthed(true);
                        }).catch(err =>{
                            setAuthenticating(false);
                        })
                } else {
                    setAuthenticating(false)
                }
            }).catch(err => {
                setAuthenticating(false);
            })
    }, [])

    const _login = (creds) => {
        removeData("token")
        removeData("billingAccount")
        setAuthenticating(true);
        setError(null)
        return new Promise((resolve, reject) => {
            login(creds)
                .then(response => {
                    getUser()
                        .then((user) => {
                            setUser(user);
                            setAuthenticating(false);
                            setAuthed(true);
                        }).catch(err => {
                            setAuthenticating(false);
                        })
                    resolve(response);
                })
                .catch(err => {
                    setError(err);
                    setAuthenticating(false)
                    reject(err)
                })
        })
    };

    const _logout = () => {
        removeData("token")
        removeData("billingAccount")
        setUser(undefined);
        logout();
        setAuthed(false);
    }

    let context: IAuthContext =
    {
        error,
        authenticating,
        authed,
        login: _login,
        logout: _logout,
        user,
        updateUser: setUser
    }

    return (
        context
    );
}

export { Context, SecureContext, useSecurity, useSecurityStatus };
export type { IAuthContext };

